// extracted by mini-css-extract-plugin
export default {"badge":"TransactionModelBadge_badge__K0UAx"};